import Address from './Address'
import CreditCard from './CreditCard'
import ShoppingCart from './ShoppingCart'
import Coupon from './Coupon'

export default {
  install (Vue, options) {
    Vue.component('address-form', Address)
    Vue.component('credit-card-form', CreditCard)
    Vue.component('shopping-cart', ShoppingCart)
    Vue.component('coupon', Coupon)
  }
}
